import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

// components
import { OpportunityNotFoundComponent } from '../components/opportunity-view/opportunity-not-found/opportunity-not-found.component';

// guards
// tests whether opp returned 404, also (incidentally but crucially) sets local OpportunityDetails object
import { OpportunityViewGuardService } from './guards/opportunity-view-guard.service';
// whether a user has edit permission
import { OpportunityManageGuardService } from './guards/opportunity-manage-guard.service';
// whether an opp has an external provider
import { OpportunityInterestedGuardService } from './guards/opportunity-interested-guard.service';

// routes
import { OPPORTUNITIES_ROUTES } from './opportunities.routes';
import { SharedModule } from '@app/shared/shared.module';

@NgModule({
  declarations: [OpportunityNotFoundComponent],
  imports: [
    CommonModule,
    // Linter error - TODO: Why does the routing module need Shared? - Potential code smell
    SharedModule,
    RouterModule.forChild(OPPORTUNITIES_ROUTES),
  ],
  exports: [RouterModule],
  providers: [
    OpportunityInterestedGuardService,
    OpportunityManageGuardService,
    OpportunityViewGuardService,
  ],
})
export class OpportunitiesRoutingModule {}
